/**
 * Custom error class for server errors that preserves the HTTP status code
 */
export class ServerError extends Error {
  public statusCode: number;
  public statusText: string;

  constructor(statusCode: number, statusText: string, message?: string) {
    // Use the provided message or fall back to status text
    super(message || `${statusCode} ${statusText}`);
    this.name = 'ServerError';
    this.statusCode = statusCode;
    this.statusText = statusText;
  }
}

/**
 * Type guard to check if an error is a ServerError
 */
export function isServerError(error: unknown): error is ServerError {
  return error instanceof ServerError;
}